import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AppGlobals } from '@app/app.global';
import { AuthService } from '@core/services';

@Injectable()
export class OwnerGuard implements CanActivate {
    constructor(private readonly router: Router,
        private readonly authService: AuthService,
        private readonly appGlobals: AppGlobals) { }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.authService.user?.isOwner) {
            return true;
        } else {
            this.router.navigate(this.appGlobals.homePath);
            return false;
        }
    }
}